'use strict';

let idCounter = 0;

const createDialog = (src, alt) => {
    const id = `image-modal-${++idCounter}`;
    const dialog = document.createElement('dialog');
    dialog.id = id;
    dialog.className = 'image-modal image-modal--loading';
    dialog.closedBy = 'any';
    dialog.setAttribute('aria-labelledby', `${id}-title`);

    const heading = document.createElement('h2');
    heading.id = `${id}-title`;
    heading.className = 'image-modal__title';
    heading.textContent = alt || 'Image';

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'image-modal__close';
    closeButton.setAttribute('aria-label', 'Close image');
    closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>`;

    closeButton.addEventListener('click', () => {
        dialog.close();
    });

    const loader = document.createElement('div');
    loader.className = 'image-modal__loader';
    loader.setAttribute('aria-label', 'Loading image');
    loader.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>`;

    const media = document.createElement('div');
    media.id = `${id}-media`;
    media.className = 'image-modal__media';

    const img = document.createElement('img');
    img.className = 'image-modal__image';
    img.alt = alt || '';

    media.appendChild(img);
    dialog.append(heading, closeButton, loader, media);
    document.body.appendChild(dialog);

    const mounted = new Promise(resolve => { // eslint-disable-line compat/compat
        img.addEventListener('load', () => {
            loader.remove();

            const aspectRatio = img.naturalWidth / img.naturalHeight;
            dialog.style.setProperty('--aspect-ratio', aspectRatio);

            if (aspectRatio > 1) {
                dialog.classList.add('image-modal--landscape');
            } else if (aspectRatio < 1) {
                dialog.classList.add('image-modal--portrait');
            } else {
                dialog.classList.add('image-modal--square');
            }

            dialog.classList.remove('image-modal--loading');
            dialog.classList.add('image-modal--loaded');
            resolve();
        }, { once: true });

        img.src = src;
    });

    const handleClose = () => {
        dialog.classList.remove('image-modal--active');
    };

    dialog.addEventListener('close', handleClose);
    dialog.addEventListener('cancel', handleClose);

    return {
        showModal: () => {
            dialog.showModal();

            mounted.then(() => {
                dialog.classList.add('image-modal--active');
            });
        },
    };
};

export default function () {
    const elements = document.querySelectorAll('.js-image-modal');

    for (const element of elements) {
        const src = element.href;
        const alt = element.querySelector('img')?.alt || '';

        let dialog = null;

        element.addEventListener('click', event => {
            event.preventDefault();

            if (!dialog) {
                dialog = createDialog(src, alt);
            }

            dialog.showModal();
        });
    }
}
